export const PRESCRIBER_SCHEDULING_WINDOW_DAYS = 180;
export const THERAPIST_SCHEDULING_WINDOW_DAYS = 30;
export const DEFAULT_SESSION_DURATION_MINUTES = 55;
export const DEFAULT_APPOINTMENT_DURATION_MINUTES = 60;
export const PRESCRIBER_UNDER_18_DURATION_MINUTES = 90;

export const APPOINTMENT_TYPE_NAME = {
  NEW_PRESCRIBER_60: "new_prescriber_60",
  NEW_PRESCRIBER_TH_60: "new_prescriber_th_60",
  NEW_PRESCRIBER_90: "new_prescriber_90",
  NEW_PRESCRIBER_TH_90: "new_prescriber_th_90",
  NEW_THERAPIST_60: "new_therapist_60",
  NEW_THERAPIST_TH_60: "new_therapist_th_60",
} as const;

export type AppointmentTypeName =
  (typeof APPOINTMENT_TYPE_NAME)[keyof typeof APPOINTMENT_TYPE_NAME];
